import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const Card = ({ t, big, i }) => (
  <figure data-testid={`testimonial-${i}`}
    className={`group relative flex h-full flex-col justify-between rounded-[28px] border p-7 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 sm:p-9 ${big ? "border-transparent bg-[#2E1065] text-white hover:shadow-[0_30px_60px_-30px_rgba(124,58,237,.8)]" : "border-violet-200 bg-white hover:shadow-[0_30px_60px_-30px_rgba(46,16,101,.35)]"}`}>
    <Quote className={`h-8 w-8 ${big ? "text-[#60A5FA]" : "text-[#7C3AED]"}`} aria-hidden />
    <blockquote className={`mt-6 ${big ? "serif-accent text-2xl leading-snug sm:text-[28px]" : "text-lg font-semibold leading-snug text-[#13052A]"}`}>
      “{t.quote}”
    </blockquote>
    <figcaption className="mt-8 flex items-center gap-3">
      <span className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-extrabold ${big ? "bg-white/10 text-white" : "bg-[#EDE9FE] text-[#581C87]"}`}>
        {t.name.replace("Dr. ", "").split(" ").map((p) => p[0]).join("")}
      </span>
      <span>
        <span className={`block text-sm font-bold ${big ? "text-white" : "text-[#13052A]"}`}>{t.name}</span>
        {t.role && <span className={`block text-xs ${big ? "text-violet-200" : "text-slate-500"}`}>{t.role}</span>}
      </span>
    </figcaption>
  </figure>
);

export const Testimonials = ({ items = [] }) => {
  if (!items.length) return null;
  const sorted = [...items].sort((a, b) => (b.quote?.length || 0) - (a.quote?.length || 0));
  const [feature, ...rest] = sorted;
  return (
    <div className="grid gap-5 lg:grid-cols-2" data-testid="testimonials-grid">
      <Reveal className="lg:row-span-3"><Card t={feature} big i={0} /></Reveal>
      {rest.map((t, i) => (
        <Reveal key={t.id || t.name} delay={0.08 * (i + 1)}><Card t={t} i={i + 1} /></Reveal>
      ))}
    </div>
  );
};
